// Define your action types
export const ACTION_TYPE_LANG = "ACTION_TYPE_LANG";

export const setLang = (payload) => ({
  type: ACTION_TYPE_LANG,
  payload,
});
